import { useState } from "react";
import { useTranslation } from "react-i18next";

import { PortalTopBanners } from "@/components/Interface/Alert/PortalTopBanners";
import { DefaultPageLayout } from "@/components/Layout/BaseLayouts/DefaultPageLayout";
import { FCC } from "@/types";

import { LogInForm } from "./LogInForm";
import { RegisterForm } from "./RegisterForm";

export const WelcomeScreen: FCC = () => {
  const { t } = useTranslation();
  const [switchForm, setSwitchForm] = useState(true);

  return (
    <DefaultPageLayout>
      <PortalTopBanners placement="welcome" className="z-40 col-span-full" />
      <div
        className="col-span-full flex flex-col items-center"
        data-testid="welcome-content"
      >
        {switchForm ? (
          <LogInForm enableMagicLinkLogin>
            <p className="text-body-xs leading-md text-foreground-primary">
              <span className="mr-1">
                {t("newWelcome.logInForm.noAccount")}
              </span>
              <button
                type="button"
                onClick={() => setSwitchForm(!switchForm)}
                className="inline-block w-fit cursor-pointer border-b border-solid border-foreground-primary pb-px text-body-xs !font-semibold text-foreground-primary hover:border-b-2 hover:pb-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-foreground-primary"
              >
                {t("newWelcome.logInForm.registerNow")}
              </button>
            </p>
          </LogInForm>
        ) : (
          <RegisterForm
            handleVerifyEmailModalClose={() => setSwitchForm(!switchForm)}
          >
            <p className="text-body-xs leading-md text-foreground-primary">
              <span className="mr-1">
                {t("newWelcome.registerForm.accountExists")}
              </span>
              <button
                type="button"
                onClick={() => setSwitchForm(!switchForm)}
                className="inline-block w-fit cursor-pointer border-b border-solid border-foreground-primary pb-px text-body-xs !font-semibold text-foreground-primary hover:border-b-2 hover:pb-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-foreground-primary"
              >
                {t("newWelcome.registerForm.logInNow")}
              </button>
            </p>
          </RegisterForm>
        )}
      </div>
    </DefaultPageLayout>
  );
};
